<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.users.edit_title')"
  :rightActions="rightActions"
  :width="700"
)
  UiFormGroup
    UiAlert(
      variant="danger"
      v-if="this.error !== null"
    ) {{ this.error }}

  UiFormGroup(
    :label="$t('companies.users.name')"
    :vuelidateModel="v$.form.name"
  )
    UiInput#name-input(
      v-model="form.name"
      :error="v$.form.name.$error"
      :disabled="inProgress"
    )
  UiFormGroup(
    :label="$t('companies.users.email')"
    :vuelidateModel="v$.form.email"
  )
    UiInput#email-input(
      v-model="form.email"
      :error="v$.form.email.$error"
      type="email"
      :disabled="inProgress"
    )
  UiFormGroup(
    :label="$t('companies.users.role')"
    :vuelidateModel="v$.form.role"
  )
    UiMultiselect#role-input(
      v-model="form.role"
      :options="globalRolesOptions"
      :disabled="inProgress"
      :canClear="false"
      :canDeselect="false"
      :error="v$.form.role.$error"
    )
  UiFormGroup
    RestTable(
      namespace="user_companies"
      :headers="headers"
      ref="userCompaniesTable"
      :itemsPerPageAttachDropdownToBody="false"
      :fetchHandler="getData"
    )
      template(#cell:role="{ item }")
        UiMultiselect(
          v-model="item.role"
          :options="rolesOptions"
          @update:modelValue="updateCompanyUser(item)"
          :canClear="false"
          :canDeselect="false"
        )
      template(#cell:actions="{ item }")
        UiButton(
          size="sm"
          variant="smooth-danger"
          @click="deleteCompanyUser(item)"
          icon="Trash"
        ) {{ $t("actions.delete") }}
</template>

<script>
import ApiAdminUsers from "@/api/admin_user.js";
import useVuelidate from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        name: {
          required,
        },
        email: {
          required,
          email,
        },
        role: {
          required,
        },
      },
    };
  },

  data() {
    return {
      inProgress: false,
      show: false,
      form: {},
      user_id: null,
      error: null,
      rolesOptions: [
        { label: "Admin", value: "admin" },
        { label: "Reader", value: "reader" },
        { label: "Guest", value: "guest" },
      ],
      globalRolesOptions: [
        { label: "Super admin", value: "super_admin" },
        { label: "Reseller", value: "reseller" },
        { label: "User", value: "user" },
      ],
      headers: [
        {
          key: "id",
          label: "#",
          squeeze: true,
        },
        {
          key: "company_name",
          label: "Company",
        },
        {
          key: "role",
          label: "role",
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    close() {
      this.show = false;
    },

    open(user) {
      this.v$.$reset();
      this.user_id = user.id;
      this.form = {
        id: user.id,
        name: user.name,
        email: user.email,
        role: user.role,
      };
      this.error = null;
      this.show = true;
    },

    save() {
      this.inProgress = true;
      this.v$.$validate().then((res) => {
        if (!res) {
          this.inProgress = false;
          return;
        }
        const form = this.form;
        const params = {
          name: form.name,
          email: form.email,
          role: form.role,
        };
        ApiAdminUsers.updateUser(form.id, params)
          .then((resp) => {
            this.inProgress = false;
            this.$emit("done");
            this.error = resp.data.error || null;
            if (this.error == null) {
              this.show = false;
            }
          })
          .catch(() => {
            this.inProgress = false;
          });
      });
    },

    reloadList() {
      this.$refs.userCompaniesTable.fetchData();
    },

    getData(params, config) {
      return ApiAdminUsers.userCompanies(this.user_id, params, config).then(
        (resp) => {
          return {
            items: resp.data.users_companies,
            meta: resp.data.meta,
          };
        },
      );
    },

    updateCompanyUser(item) {
      ApiAdminUsers.updateCompanyUser(this.user_id, {
        id: item.id,
        role: item.role,
      })
        .then((res) => {
          this.reloadList();
          this.error = res.data.error || null;
        })
        .catch((e) => {});
    },

    deleteCompanyUser(item) {
      ApiAdminUsers.deleteCompanyUser(this.user_id, item.id)
        .then((res) => {
          this.reloadList();
          this.error = res.data.error || null;
        })
        .catch((e) => {
          this.error = e;
        });
    },
  },
};
</script>
